module.exports = __webpack_public_path__ + "static/media/B1.1f63a700.png";